export const TAB_ITEMS = [
  { value: 'assessment', label: '評価結果' },
  { value: 'answers', label: '回答結果' },
];
